import { debugWarn } from '../utils/debug';
import type { TokenRefreshFunction } from './BaseApiService';

let _refreshImpl: (() => Promise<boolean>) | null = null;

/**
 * Register the token refresh implementation. Called by AuthApiService so
 * tokenRefresh does not need to import authApiService (avoids circular dependency).
 */
export function registerTokenRefresh(fn: () => Promise<boolean>): void {
    _refreshImpl = fn;
}

/**
 * Shared token refresh function that can be used by all API services.
 * Implementation is registered by AuthApiService at startup.
 */
export const createTokenRefreshFunction = (): TokenRefreshFunction => {
    return async (): Promise<boolean> => {
        if (!_refreshImpl) return false;
        try {
            return await _refreshImpl();
        } catch (error: any) {
            debugWarn('[TokenRefresh] Token refresh failed:', error);
            return false;
        }
    };
};

/**
 * Shared token refresh function instance for all services to use
 */
export const sharedTokenRefresh = createTokenRefreshFunction();
